const moment = require('moment-timezone');

module.exports = function (value, eventDetails = {}) {
  const output =
    value && value.toString().length
      ? eventDetails && eventDetails.timezone
        ? moment(value, 'YYYY-MM-DD')
            // .tz(eventDetails.timezone) // @NOTE: This causes dates to go 1 day earlier
            .format('M-DD-YYYY')
        : moment(value).format('M-DD-YYYY')
      : '';

  return output;
};
